"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orchestraMsaApi = void 0;
const waken = {
    method: "GET",
    url: `${process.env.REACT_APP_ORCHESTRA_URL || process.env.REACT_APP_ORCHESTRA_BE_URL}/msa/waken`,
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.orchestraMsaApi = { waken };
//# sourceMappingURL=orchestra.js.map